module.exports = __webpack_public_path__ + "img/Mentorship.a0d3b177.png";